import { initValidatedForm } from '../components/form-validation.js';

(function () {
    initGameFormValidation();
})();

export function initGameFormValidation(documentRef = globalThis.document) {
    const page = documentRef?.querySelector?.('[data-page-view="game-form"]');
    if (!(page instanceof HTMLElement)) {
        return;
    }

    const form = page.querySelector('[data-game-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const statusInput = form.querySelector('select[name="status"]');
    const ratingInput = form.querySelector('input[name="rating"]');

    if (!(statusInput instanceof HTMLSelectElement) || !(ratingInput instanceof HTMLInputElement)) {
        return;
    }

    initValidatedForm({
        form,
        fields: [
            {
                ...buildGameFieldConfig(statusInput, {
                    valueMissing: 'Status is required.',
                }),
                // The select stays the value; the status combobox input is what the user sees and focuses.
                target: form.querySelector('[data-game-form-status-input]') ?? undefined,
            },
            {
                ...buildGameFieldConfig(ratingInput, {}),
                // A number input reports range/step/unparsable input through separate flags; all of them
                // mean the same backend rule, so they share one message instead of the browser's wording.
                getCustomMessage: () => {
                    const validity = ratingInput.validity;

                    return validity.rangeUnderflow || validity.rangeOverflow || validity.stepMismatch || validity.badInput
                        ? 'Rating must be from 0 to 10 with up to one decimal place.'
                        : '';
                },
            },
        ],
    });
}

function buildGameFieldConfig(input, messages) {
    return {
        input,
        errorContainer: input.parentElement,
        errorElement: input.parentElement?.querySelector?.('.game-form-error') ?? null,
        errorClassName: 'game-form-error',
        messages,
    };
}
